export default __webpack_public_path__ + "static/media/deliveryIcon.a92ef6fa.svg";